export default "/Frontend/dist/event-background2.1f463ae9ab1937e6b991445295d7c7bb.svg";